import { styled, useTheme } from '@mui/material';
import { Flex, FlexProps } from '../layout';

type AppLogoProps = FlexProps & {
  logoImg: string;
  imgStyles?: React.CSSProperties;
};

export const AppLogo = ({ logoImg,  imgStyles, ...props}: AppLogoProps) => {
  const theme = useTheme();
  return (
    <AppLogoStyledFlex alignCenter justifyCenter {...props}>
      <img src={logoImg} alt="Logo" height="22px" style={imgStyles} />
    </AppLogoStyledFlex>
  );
};

const AppLogoStyledFlex = styled(Flex)(({ theme }) => ({
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  border: `1px solid ${theme.palette.divider}`,
}));
